(function auditModuleDefinition() {
    'use strict';

    angular.module('Audit', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function auditConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('audit-find', {
                    url: "/Audit/Find",
                    templateUrl: config.resourceUrl('/views/audit/audit-find.html'),
                    controller: 'AuditFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('AUDIT READ').or('RSD').or('RRHH_CONTENT')
                });

                $stateProvider.state('audit-detail', {
                    url: "/Audit/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/audit/audit-detail.html'),
                    controller: 'AuditDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('AUDIT READ').or('RSD').or('RRHH_CONTENT')
                });

                $stateProvider.state('audit-history', {
                    url: "/Audit/History/{entityName}/",
                    templateUrl: config.resourceUrl('/views/audit/audit-history.html'),
                    controller: 'AuditHistoryController',
                    authorize: true,
                    roles: loginProvider.roleCondition('AUDIT READ').or('RSD').or('RRHH_CONTENT'),
                    params: { entityValues: null, displayName: null, organizationalUnitId: null }
                });
            }
        ]);
})();
